import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
var selectStatesDomain = function (state) {
    return (state && state.environments) || getInitialState();
};
export var selectEnvironments = createSelector(selectStatesDomain, function (state) { return state; });
